import { get, post, put, del } from './api.service';
import { User, UserRole } from '../types';

export interface UserCreateInput {
  email: string;
  name: string;
  roles?: UserRole[];     // Multiple roles support
  role?: UserRole;        // Backwards compatibility
  password?: string;
  isActive?: boolean;
}

export interface UserUpdateInput {
  name?: string;
  roles?: UserRole[];     // Multiple roles support
  role?: UserRole;        // Backwards compatibility
  isActive?: boolean;
  assignedClientIds?: string[];
  employeeId?: string;
}

// ============================================================================
// USER API
// ============================================================================

export async function getAllUsers(): Promise<{ users: User[] }> {
  return get<{ users: User[] }>('/users');
}

export async function getUserById(userId: string): Promise<{ user: User }> {
  return get<{ user: User }>(`/users/${userId}`);
}

export async function createUser(data: UserCreateInput): Promise<{ user: User }> {
  return post<{ user: User }>('/users', data);
}

export async function updateUser(userId: string, data: UserUpdateInput): Promise<{ user: User }> {
  return put<{ user: User }>(`/users/${userId}`, data);
}

export async function deleteUser(userId: string): Promise<{ message: string }> {
  return del<{ message: string }>(`/users/${userId}`);
}

export async function toggleUserStatus(userId: string, isActive: boolean): Promise<{ user: User }> {
  return put<{ user: User }>(`/users/${userId}/status`, { isActive });
}

export const userService = {
  getAllUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
  toggleUserStatus,
};

export default userService;
